













































































import { Component, Mixins } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterTypes, FilterOperators } from "@/data/table";
import { CancellationRequestStatusCodes } from "@/data/enums/contractProducts";

@Component({
  components: {
    "cancellation-request-row": () =>
      import("@/components/app/global/contracts/cancellationRequestRow.vue")
  }
})
export default class ContractCancellationRequestsTable extends Mixins(
  FilteringSortingTableStore
) {
  public dataModule = DataModules.CONTRACTS;
  public filters: IFilter[] = [
    {
      key: "created_at",
      label: this.$t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    },
    {
      key: "contract.client.username",
      label: this.$t("_.client_username"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS,
      group: "client"
    },
    {
      key: "contract.client.firstname",
      label: this.$t("_.client_firstname"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS,
      group: "client"
    },
    {
      key: "contract.client.lastname",
      label: this.$t("_.client_lastname"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS,
      group: "client"
    },
    {
      key: "contract.client.created_at",
      label: this.$t("_.client_created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.AFTER,
      group: "client"
    },
    {
      key: "contract.client.id",
      label: this.$t("_.client_id"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL,
      group: "client"
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "created_at",
      label: this.$t("_.date_created")
    }
  ];

  public guardFunctionalities = ["list_contract_cancellation_request"];

  public created() {
    this.apiProps = {
      with: [
        "contract.client.image",
        "contract_product.product.image",
        "contract_product.provision_provider.logos",
        "status"
      ].join()
    };
    this.getData();
  }

  public get onlyPendingFilter() {
    return {
      "filter[status.code]":
        CancellationRequestStatusCodes.CANCELLATION_REQUEST_REQUESTED
    };
  }

  // overrides mixin method
  public storeGetData(params: any): Promise<any> {
    params.props = {
      ...params.props,
      ...this.onlyPendingFilter
    };
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/listCancellationRequests`,
      params
    );
  }
}
